export enum Statistic2ReportDetailsType {
    ReportName = 0,
    ReportType = 1,
    ReportFromDate = 2,
    ReportToDate = 3,
    ReportUserSelection = 4,
    ReportObject = 5,
}
